import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

const TotalDocumentCell: FC<GridCellProps> = (props) => {
  const { dataItem } = props;
  const { documentType } = dataItem;
  const { displayValue } = useGridCellDisplayValue(props);

  const isReceipt = useMemo(
    () => (documentType === 'Receipt' ? 'N/A' : displayValue),
    [displayValue, documentType]
  );
  const title = useMemo(
    () => (documentType === 'Receipt' ? 'N/A' : displayValue),
    [displayValue, documentType]
  );
  return (
    <GridCellBase {...props} rowSelectionEnabled={true} title={title}>
      <p>{isReceipt}</p>
    </GridCellBase>
  );
};

export default TotalDocumentCell;
